import { useEffect, useState } from 'react';

// Service
import ReferralService from '../../services/referralService';

//Hooks
import useNotify from '../notify';
import useUser from "../user/useUser";

const defaultFilters = {
    pageSize: 10,
    pageNumber: 1
}

const useReferrals = (filters = defaultFilters, isReception = false) => {
    const { branch } = useUser();
    const { Notify, variants } = useNotify();
    const [searchResult, setSearchResult] = useState({ referrals: [], totalPage: 1 });
    const [loading, setLoading] = useState(false);
    const [loadingPrint, setLoadingPrint] = useState(false);

    useEffect(() => {
        const FindReferrals = async () => {
            setLoading(true);
            if (filters) {
                await ReferralService
                    .Search({
                        ...filters,
                        refId: branch.refId,
                        WarehouseId: branch.warehouseId,
                        WarehouseDestinationId: isReception 
                            ? branch.warehouseId 
                            : filters.WarehouseDestinationId,
                    })
                    .then(res => setSearchResult(state => ({
                        ...state,
                        referrals: res.values,
                        totalPage: res.totalPage,
                        totalResults: res.totalResults
                    })))
                    .finally(() => setLoading(false));
            }
        }

        if (branch.warehouseId)
            FindReferrals();
    }, [branch, filters, isReception])

    const printReferral = (referralId) => {
        setLoadingPrint(true);

        return ReferralService
            .GetVoucher(referralId)
            .then((res) => {
                Notify("Remito impreso correctamente", variants.SUCCESS);
                return res;
            })
            .catch((err) => Notify("Error al intentar imprimir remito: " + err?.message, variants.ERROR))
            .finally(() => setLoadingPrint(false));
    }

    return {
        ...searchResult,
        loading,
        printReferral,
        loadingPrint
    }
}

export default useReferrals;